<h2 mat-dialog-title class="confirm-sync-title">Confirmar atualização</h2>

<div mat-dialog-content class="confirm-sync-content">
  <p *ngIf="hasEmail">
    Você está prestes a atualizar o status de <strong >{{ data.title }}</strong>
    para o usuário <strong class="confirm-sync-email">{{ data.email }}</strong>.
    <br/><br/>
    Essa ação vai sincronizar novamente os dados desse acesso. Deseja continuar?
  </p>
  <p *ngIf="!hasEmail">
    Você está prestes a atualizar o status de <strong>{{ data.title }}</strong>
    para este colaborador. Essa ação vai sincronizar novamente os dados desse acesso.
    Deseja continuar?
  </p>
</div>

<div mat-dialog-actions align="end" class="confirm-sync-actions">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
    Cancelar
  </button>
  <button type="button" class="btn btn-confirm-sync" (click)="onConfirm()">
    Atualizar
  </button>
</div>
